import { render } from "./BadResponseViewer.vue?vue&type=template&id=4a64d6c7&ts=true"
import script from "./BadResponseViewer.vue?vue&type=script&lang=ts"
export * from "./BadResponseViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__